import { motion } from "framer-motion";
import { Cube, Wrench, Robot, Compass } from "@phosphor-icons/react";
import { useLang } from "@/lib/LangContext";

const ICONS = [Cube, Wrench, Robot, Compass];

export const Services = () => {
  const { t } = useLang();
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 lg:py-32 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <p className="font-mono-x text-xs tracking-[0.3em] text-brand-500 font-bold">
              {t.services.overline}
            </p>
            <h2 className="mt-4 font-display font-medium tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl">
              {t.services.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-4">
            <p className="font-mono-x text-sm sm:text-base text-slate-300 leading-relaxed">
              {t.services.description}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                data-testid={`service-item-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group bg-black p-10 hover:bg-slate-950/70 transition-colors duration-300 relative"
              >
                <div className="flex items-start gap-6">
                  <div className="w-12 h-12 border border-white/20 flex items-center justify-center flex-shrink-0 group-hover:border-brand-500 group-hover:text-brand-500 transition-colors duration-200">
                    <Icon size={22} weight="regular" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-2xl text-white tracking-tight">
                      {s.title}
                    </h3>
                    <p className="mt-3 font-mono-x text-sm text-slate-300 leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </div>
                <div className="mt-8 font-mono-x text-[10px] tracking-[0.3em] text-slate-500">
                  0{i + 1} / 0{t.services.items.length}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
